var noop = function noop() {};

export default noop;


// WEBPACK FOOTER //
// ./node_modules/bootstrap-vue/esm/utils/noop.js